import { Button, Grid, Input, Segment } from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import STATUT_PROJET from '../../constants/common/statutProjet';
import type AutorisationStatutCount from '../../interfaces/common/autorisationStatutCount';
import './AutorisationFilters.css';

export interface AutorisationFiltersData {
	statut?: number;
	q?: string;
}

interface AutorisationFiltersProps {
	autorisationStatutCount: AutorisationStatutCount;
	filters: AutorisationFiltersData;
	onFilters: (filters: AutorisationFiltersData) => void;
}

const AutorisationFilters = ({
	autorisationStatutCount,
	filters,
	onFilters,
}: AutorisationFiltersProps) => {
	const handleStatut = (statut: number) => {
		onFilters({ statut });
	};

	const handleBlurQuery = (e: React.FocusEvent<HTMLInputElement>) => {
		onFilters({ q: e.target.value });
	};

	return (
		<Segment>
			<Grid>
				<Grid.Row verticalAlign="middle">
					<Grid.Column className="autorisationFiltersColumn" width={6}>
						<Button
							basic={filters.statut !== STATUT_PROJET.EN_COURS}
							circular
							color="blue"
							data-testid={`autorisationFilters${STATUT_PROJET.EN_COURS}`}
							onClick={() => {
								handleStatut(STATUT_PROJET.EN_COURS);
							}}
							size="tiny"
						>
							<Icon
								color={
									filters.statut === STATUT_PROJET.EN_COURS ? 'white' : 'blue'
								}
								iconSet="Lucide"
								name="Loader"
								size={16}
							/>
							{`En cours (${autorisationStatutCount.enCours})`}
						</Button>
						<Button
							basic={filters.statut !== STATUT_PROJET.BROUILLON}
							circular
							color="grey"
							data-testid={`autorisationFilters${STATUT_PROJET.BROUILLON}`}
							onClick={() => {
								handleStatut(STATUT_PROJET.BROUILLON);
							}}
							size="tiny"
						>
							<Icon
								color={
									filters.statut === STATUT_PROJET.BROUILLON ? 'white' : 'grey'
								}
								iconSet="Lucide"
								name="FilePen"
								size={16}
							/>
							{`Brouillons (${autorisationStatutCount.brouillon})`}
						</Button>
						<Button
							basic={filters.statut !== STATUT_PROJET.SOLDE}
							circular
							color="green"
							data-testid={`autorisationFilters${STATUT_PROJET.SOLDE}`}
							onClick={() => {
								handleStatut(STATUT_PROJET.SOLDE);
							}}
							size="tiny"
						>
							<Icon
								color={
									filters.statut === STATUT_PROJET.SOLDE ? 'white' : 'green'
								}
								iconSet="Lucide"
								name="Check"
								size={16}
							/>
							{`Soldées (${autorisationStatutCount.solde})`}
						</Button>
						<Button
							basic={filters.statut !== STATUT_PROJET.TOUTES}
							circular
							color="purple"
							data-testid={`autorisationFilters${STATUT_PROJET.TOUTES}`}
							onClick={() => {
								handleStatut(STATUT_PROJET.TOUTES);
							}}
							size="tiny"
						>
							<Icon
								color={
									filters.statut === STATUT_PROJET.TOUTES ? 'white' : 'purple'
								}
								iconSet="Lucide"
								name="CheckCheck"
								size={16}
							/>
							{`Toutes (${autorisationStatutCount.toutes})`}
						</Button>
					</Grid.Column>
					<Grid.Column textAlign="right" width={10}>
						<Input
							fluid
							icon="search"
							iconPosition="left"
							onBlur={handleBlurQuery}
							placeholder="Rechercher..."
							value={filters.q}
						/>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</Segment>
	);
};

export default AutorisationFilters;
